/* NPM PACKAGES */
import Axios from 'axios';
import VueClipboard from 'vue-clipboard2';
import VCalendar from 'v-calendar';
import 'bulma/css/bulma.css';

import Vue from 'vue';
import App from './App.vue';

/* SSS custom CSS */
import './styles';
import './styles/colors.scss';

/* Define header globally */
import header from './components/Header.vue';
import adminHeader from './components/admin/Header.vue';

/* Define reusable components globally */
import './components/core';

/* Define toast globally */
import toast from './components/utils/Toast.vue';

import store from './store';
import router from './routes';

Vue.component('SssHeader', header);
Vue.component('AdminHeader', adminHeader);
// eslint-disable-next-line
Vue.component('Toast', toast);

Vue.prototype.$axios = Axios;
Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VCalendar, {
  componentPrefix: 'vc'
});

/* Filter money display into $ */
// @deprecated filters in Vue 3 - use methods instead
// @todo should be part of utilities
Vue.filter('toCurrency', (value) => {
  if (typeof value !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.directive('restrict', {
  componentUpdated(el, binding, vnode) {
    const {
      value, oldValue, expression, arg: restrictValue
    } = binding;
    const modelName = expression.split('.')[1];

    if (value !== oldValue && !RegExp(`^${restrictValue}*$`).test(value)) {
      el.value = oldValue;
      vnode.context.models = {
        ...vnode.context.models,
        [modelName]: oldValue
      };
    }
  }
});

new Vue({
  router,
  store,
  data() {
    return {
      pageTitle: 'Self Storage Solution',
      showCompanies: false,
      showLocationAdd: false,
      showStateAdd: false,
      // showHeader: true, // hide top navigation if set to false (used on login page for example)
      showNavigation: true, // hide main navigation if set to false (used on intro pages for example)
      // hide logo link (back home) and set an arrow instead
      // if goBackLink get a route name (used on workflow page for example)
      goBackLink: null
    };
  },
  render: (h) => h(App)
}).$mount('#app');
